export default __webpack_public_path__ + "static/media/spaceman1.1d0d92b1.png";